// frontend/src/store/accessStore.js
// Set when the API answers 402 TRIAL_EXPIRED / SUBSCRIPTION_REQUIRED, so Layout
// can show the "trial has ended" screen at once instead of waiting for /hotel.
import { create } from 'zustand';

export const useAccessStore = create((set) => ({
  blocked: null, // { code, trialEndsAt, graceEndsAt, at }
  setBlocked: (info) => set((s) => (s.blocked ? s : { blocked: { ...info, at: Date.now() } })),
  clear: () => set({ blocked: null }),
}));
